"use client";

import { useState } from "react";

interface FlagIconProps {
  countryCode: string;
  size?: number;
  className?: string;
  alt?: string;
}

export function FlagIcon({
  countryCode,
  size = 20,
  className = "",
  alt = "",
}: FlagIconProps) {
  const [error, setError] = useState(false);
  const code = countryCode.toLowerCase();
  const height = Math.round(size * 0.75);

  if (error) {
    return (
      <span
        className={`inline-flex items-center justify-center text-muted-foreground ${className}`}
        style={{ width: size, height }}
        data-testid={`flag-error-${code}`}
      >
        🏳️
      </span>
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={`https://flagcdn.com/${code}.svg`}
      width={size}
      height={height}
      alt={alt || `Flag of ${code.toUpperCase()}`}
      className={`inline-block object-cover rounded-sm ${className}`}
      loading="lazy"
      onError={() => setError(true)}
      data-testid={`flag-${code}`}
    />
  );
}
